export enum IOrgAnalyticsActivityEnum {
  Duration = 'OrgAnalyticsActivity.duration',
  StartTime = 'OrgAnalyticsActivity.starttime',
  LocalStartTime = 'OrgAnalyticsActivity.localstarttime',
  LocalStartDate = 'OrgAnalyticsActivity.localStartDate',
  LocalEndTime = 'OrgAnalyticsActivity.localendtime',
  LocalEndDate = 'OrgAnalyticsActivity.localenddate',
  Count = 'OrgAnalyticsActivity.count',
  AppId = 'OrgAnalyticsActivity.appid',
  SubscriptionId = 'OrgAnalyticsActivity.subscriptionid',
  AverageDailyDuration = 'OrgAnalyticsActivity.averageDailyDuration',
  AverageInteractionDuration = 'OrgAnalyticsActivity.averageInteractionDuration',
  UserId = 'OrgAnalyticsActivity.userid',
  StartTimeDay = 'OrgAnalyticsActivity.starttime.day',
  LocalStartTimeDay = 'OrgAnalyticsActivity.localstarttime.day',
  LocalStartTimeWeek = 'OrgAnalyticsActivity.localstarttime.week',
  DayCount = 'OrgAnalyticsActivity.dayCount',
  Id = 'OrgAnalyticsActivity.teamId',
  PerUserAvgDuration = 'OrgAnalyticsActivity.perUserAvgDuration',
  PerUserAvgCount = 'OrgAnalyticsActivity.perUserAvgCount',
  TotalDuration = 'OrgAnalyticsActivity.totalDuration',
  MaxDuration = 'OrgAnalyticsActivity.maxDuration',
  AverageDailyInteractions = 'OrgAnalyticsActivity.averageDailyInteractions',
  AverageWeeklyDuration = 'OrgAnalyticsActivity.averageWeeklyDuration',
  AverageWeeklyInteractions = 'OrgAnalyticsActivity.averageWeeklyInteractions',
  WeekCount = 'OrgAnalyticsActivity.weekCount',
  UserCount = 'OrgAnalyticsActivity.userCount',
  PerUserAvgDailyDuration = 'OrgAnalyticsActivity.perUserAvgDailyDuration',
  PerUserAvgDailyInteractions = 'OrgAnalyticsActivity.perUserAvgDailyInteractions',
  PerUserAvgWeeklyDuration = 'OrgAnalyticsActivity.perUserAvgWeeklyDuration',
  PerUserAvgWeeklyInteractions = 'OrgAnalyticsActivity.perUserAvgWeeklyInteractions',
  HeatmapSegment = 'OrgAnalyticsActivity.heatmapsegment',
  WeekdayIndex = 'OrgAnalyticsActivity.weekdayindex',
  TotalCallDuration = 'OrgAnalyticsActivity.totalCallDuration',
  ObjectType = 'OrgAnalyticsActivity.objecttype',
  CallCount = 'OrgAnalyticsActivity.callCount',
  AppCategoryId = 'OrgAnalyticsActivity.appcategoryid',
  TeamId = 'OrgAnalyticsActivity.teamId',
  DepartmentId = 'OrgAnalyticsActivity.departmentid',
}

export enum IOrgAnalyticsActivitySegmentsEnum {
  monday = 'OrgAnalyticsActivity.monday',
  tuesday = 'OrgAnalyticsActivity.tuesday',
  wednesday = 'OrgAnalyticsActivity.wednesday',
  thursday = 'OrgAnalyticsActivity.thursday',
  friday = 'OrgAnalyticsActivity.friday',
  saturday = 'OrgAnalyticsActivity.saturday',
  sunday = 'OrgAnalyticsActivity.sunday',
}
